import { t as translate } from 'i18next'

export { Trans as TranslateComponent } from 'react-i18next'

// NOTE: Using a wrapper function to keep compatibility and avoid using `t` directly from i18next
export const t = (...args: Parameters<typeof translate>) => translate(...args)

const i18n = { t }

// NOTE: Export default to keep compatibility with the code that uses `i18n.t` directly
export default i18n
